define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog",
	"./GenerateMergedPDFController"
], function(declare, lang, _, PostRequest, locale, MessageDialog, GenerateMergedPDFController) {

	return declare(GenerateMergedPDFController, {

		/**
		 * {Number} - used for enabling the actions after timeout
		 */
		_nTimeouts: 1,

		/**
		 * {Node} - Represents current SelectSet node
		 */
		_node: null,

		_STATUS_SUCCEEDED: "Succeeded",

		_STATUS_FAILED: "Failed;",

		postProcessSuccess: function() {
			// summary: wait for PDF request to be processed if created successfully
			var node = this.getNode();
			if (node && node.$Type == "SelectSet") {
				this._node = node;
				_.delay(lang.hitch(this, this._postProcessPdf), 5000);
			}

			return this.inherited(arguments);
		},

		/**
		 * call server to determine what the status of PDF generation is
		 */
		_postProcessPdf: function() {
			new PostRequest("SiteAdmin", "GetSelectSetPDFItemsGenerationStatus")
				.addParameter("URL", this._node.$URL)
				.post({}).then(lang.hitch(this, this._onValidatePDFRequestStatus));
		},

		/**
		 * Handle server response to check status of PDFRequest to report to user
		 * If succeeded/failed, present a message to the user
		 * Otherwise, check again in 5 seconds up to 5 minutes
		 */
		_onValidatePDFRequestStatus: function(response) {
			var PDFStatus = !response ? this._STATUS_SUCCEEDED : response.getReturnValue();
			if (PDFStatus == this._STATUS_SUCCEEDED) {
				new MessageDialog({
					buttons: [MessageDialog.BUTTON_OK],
					materialIcon: MessageDialog.ICON_COMPLETED,
					message: this.getString("_Finished"),
					title: locale.typeAction(this._node.$Type, "GenerateDataPackagePDFs")
				}).show();
				return;
			} else if (PDFStatus.indexOf(this._STATUS_FAILED) == 0) {
				new MessageDialog({
					buttons: [MessageDialog.BUTTON_OK],
					materialIcon: MessageDialog.ICON_ERROR,
					message: this.getString("_PDFRequestError", [PDFStatus.substring(this._STATUS_FAILED.length)]),
					title: locale.typeAction(this._node.$Type, "GenerateDataPackagePDFs")
				}).show();
				return;
			}

			if (++this._nTimeouts >= 75) {
				// do not keep sending request if it has been more than 5 minutes
				return;
			}
			_.delay(lang.hitch(this, this._postProcessPdf), 5000);
		}
	});
});
